export default __webpack_public_path__ + "52f0e863e546262301b4263fce37c9f4.svg";